// Imports
import React from "react"
import styled, { css } from "styled-components"
import { Font, Variables, Mixins } from "fajny-react"

import DemoCard from "./DemoCard"

const Container = styled(DemoCard)`
    flex-direction: column;
`

const Square = styled.span`
    width: 150px;
    height: 150px;
    margin-top: ${Variables.Spacers.S};

    ${({ $shadow, $radius, $getRadius, $boxShadow }) =>
        $shadow
            ? css`
                  box-shadow: ${$boxShadow};
              `
            : $radius &&
              css`
                  background-color: ${Variables.Colors.Danger100};
                  border-radius: ${$getRadius};
                  width: ${$getRadius === "var(--radius-round)" &&
                  "calc(100% - 24px)"};
              `}
`

const Content = styled.div`
    padding: ${Variables.Spacers.S};
    ${Mixins.Grid({
        $gap: "xs",
    })};
    width: 100%;
`

const ColumnCard = ({ shadow, radius, item, children }) => {
    const { name, variable, css, value } = item

    return (
        <Container>
            <Square
                $shadow={shadow}
                $boxShadow={shadow && css}
                $getRadius={radius && css}
                $radius={radius}
            />

            <Content>
                <Font.H6>{name}</Font.H6>

                <Font.P>
                    <Font.Strong>Variable: </Font.Strong>
                    {variable}
                </Font.P>

                <Font.P>
                    <Font.Strong>CSS: </Font.Strong>
                    {css}
                </Font.P>

                <Font.P>
                    <Font.Strong>Value: </Font.Strong>
                    {value}
                </Font.P>
            </Content>
        </Container>
    )
}

export default ColumnCard
